import { call, put, takeLatest } from 'redux-saga/effects';
import {
  showNotification,
  FETCH_START,
  FETCH_ERROR,
  FETCH_END,
  resolveRedirectTo,
} from 'react-admin';
import { push } from 'connected-react-router';
import { SAVE_AFFECTATION_BUNDLE } from '../action';
import fetchApi from './helpers/fetchApi';

export function* saveAffectationBundle({
  payload: { record, redirect, basePath },
}) {
  try {
    yield put({ type: FETCH_START });
    const res = yield call(fetchApi, {
      url: '/manageAffectation/createBundle',
      payload: record,
    });
    yield put({ type: FETCH_END });
    if (res.success === true) {
      yield put(
        showNotification(
          'notification.save_affectation_bundle.success',
          'info',
          {
            messageArgs: {
              numberAffectation: res.createdAffectation,
            },
          },
        ),
      );
      const pathToRedirectTo = resolveRedirectTo(
        redirect,
        basePath,
        record.id,
        record,
      );
      yield put(push(pathToRedirectTo));
    } else {
      yield put(showNotification(res.message, 'warning'));
    }
  } catch (err) {
    yield put({ type: FETCH_ERROR });
    yield put(
      showNotification('notification.save_affectation_bundle.fail', 'warning'),
    );
  }
}

export default function* saveAffectationBundleSaga() {
  yield takeLatest(SAVE_AFFECTATION_BUNDLE, saveAffectationBundle);
}
